<template>
    <CompassObject :object="icon" size="small" />
</template>

<script>
import { events } from './EventsTimeline';

export default {
    props: {
        log: {
            type: Object,
            required: true,
        },
    },
    computed: {
        icon() {
            let icon = 'logo';
            const event = this.log.action ?? this.log.icon;
            if (!!event) {
                if (!!events[event]) {
                    icon = events[event];
                }
            }
            return icon;
        },
    },
};
</script>
